import React from 'react';
interface Candle {
  open: number;
  close: number;
  high: number;
  low: number;
}

/** Deterministic, clearly fictional series — no live or historical market data. */
function buildCandles(count: number, seed: number): Candle[] {
  const candles: Candle[] = [];
  let last = 50;
  for (let i = 0; i < count; i += 1) {
    const wave = Math.sin((i + seed) * 0.7) * 6 + Math.cos((i + seed) * 0.31) * 4;
    const drift = i * 0.85;
    const open = last;
    const close = 44 + drift + wave;
    const high = Math.max(open, close) + 2.4 + Math.abs(Math.sin(i * 1.9)) * 2.6;
    const low = Math.min(open, close) - 2.1 - Math.abs(Math.cos(i * 1.4)) * 2.4;
    candles.push({
      open,
      close,
      high,
      low
    });
    last = close;
  }
  return candles;
}
interface CandleChartProps {
  count?: number;
  seed?: number;
  height?: number;
  showAxis?: boolean;
  className?: string;
}
export function CandleChart({
  count = 26,
  seed = 2,
  height = 180,
  showAxis = true,
  className = ''
}: CandleChartProps) {
  const candles = buildCandles(count, seed);
  const width = 320;
  const values = candles.flatMap(c => [c.high, c.low]);
  const max = Math.max(...values);
  const min = Math.min(...values);
  const span = max - min || 1;
  const slot = width / count;
  const bodyWidth = Math.max(slot * 0.52, 2.5);
  const y = (value: number) => height - (value - min) / span * (height - 16) - 8;
  const closeLine = candles.map((c, i) => `${i === 0 ? 'M' : 'L'}${(i + 0.5) * slot} ${y(c.close)}`).join(' ');
  return <svg viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="none" className={`w-full ${className}`} style={{
    height
  }} role="img" aria-label="Gráfico de velas ilustrativo con datos ficticios" data-id="element-25" data-mp="1s1609dvviy1r">
      {showAxis && [0.2, 0.45, 0.7, 0.95].map(ratio => <line key={ratio} x1={0} x2={width} y1={height * ratio} y2={height * ratio} stroke="rgba(255,255,255,0.055)" strokeWidth={1} data-id="element-26" data-mp="bnpldshz6cwr" />)}

      <path d={`${closeLine} L${width} ${height} L0 ${height} Z`} fill="rgba(247,162,59,0.09)" stroke="none" data-id="element-27" data-mp="e0rooqcz162o" />
      <path d={closeLine} fill="none" stroke="rgba(247,162,59,0.55)" strokeWidth={1.25} data-id="element-28" data-mp="3v8de3bgohim7" />

      {candles.map((candle, index) => {
      const positive = candle.close >= candle.open;
      const color = positive ? '#20C997' : '#FF4D4D';
      const cx = (index + 0.5) * slot;
      const top = y(Math.max(candle.open, candle.close));
      const bottom = y(Math.min(candle.open, candle.close));
      return <g key={index} data-id="element-29" data-mp="3cgkl3h1lzxeh" data-mpi={index}>
            <line x1={cx} x2={cx} y1={y(candle.high)} y2={y(candle.low)} stroke={color} strokeOpacity={0.55} strokeWidth={1} data-id="element-30" data-mp="3hhidemgc27tp" />
            <rect x={cx - bodyWidth / 2} y={top} width={bodyWidth} height={Math.max(bottom - top, 1.5)} fill={color} fillOpacity={positive ? 0.9 : 0.85} rx={0.8} data-id="element-31" data-mp="37ij4d2rnoa66" />
          </g>;
    })}
    </svg>;
}